export class ServiceModel {

  Id: number;
  EnName: string;
  ArName: string;
  ViewUrl: string;
  SLA?: number;
  IsCRM: boolean;
  DepartmentId: number;
  TotalRateValue: number;
  NumberOfRating: number;
  KhadamatiId: string
  FeesConfigurationId: string;
}
